<div class="login-body">
  <div class="login-image" [ngStyle]="background" (click)="calculateBackground()"></div>
  <div class="card login-panel container-fluid">
    <div class="login-panel-2fa-qr">
      <user-2fa-config (validCode)="goToMainPage($event)"></user-2fa-config>
    </div>
  </div>
</div>